import { all } from 'redux-saga/effects';
import invoiceWatcher from './invoiceDetailSaga';

export default function* rootSaga(action) {
	yield all([invoiceWatcher(action)]);
}
